<template>
  <div v-if="item">
    <button @click="downloadPdf" class="btn btn-info mb-4">Скачать PDF</button>

    <ul v-if="!question" class="questions">
      <li
        v-for="(q, key) in item.questions"
        :key="key"
        @click="questionIndex = key"
      >
        <h5>
          {{ key + 1 }}. {{ q.title }}
          <span class="text-success">({{ type[q.type]["title"] }})</span>
        </h5>
      </li>
    </ul>
    <div v-else>
      <button
        class="mb-4 btn btn-warning mr-4"
        round
        @click="questionIndex = null"
      >
        <span class="ti-list"> </span>
      </button>
      <button
        :disabled="questionIndex === 0"
        class="mb-4 btn btn-info mr-2"
        round
        @click="setPosition(true)"
      >
        <span class="ti-arrow-left"> </span>
      </button>
      <button
        :disabled="questionIndex === item.questions.length - 1"
        class="mb-4 btn btn-info"
        round
        @click="setPosition(false)"
      >
        <span class="ti-arrow-right"> </span>
      </button>
    </div>

    <component v-if="question" :is="`type-${question.type}`" :data="question" />
  </div>
</template>
<script>
import { cardContent } from "@/plugins/functions";

export default {
  components: {
    "type-glue": () => import("./Type/TypeGlue"),
    "type-text": () => import("./Type/TypeText"),
    "type-test": () => import("./Type/TypeTest"),
    "type-upload": () => import("./Type/TypeUpload"),
    "type-order": () => import("./Type/TypeOrder"),
  },
  data: () => ({
    cardLink: "business/works",
    item: null,
    // question: null,
    questionIndex: null,
    type: {
      glue: {
        title: "Склеить элементы",
      },
      text: {
        title: "написать текст",
      },
      test: {
        title: "тест",
      },
      upload: {
        title: "загрузить документ",
      },
      order: {
        title: "установить порядок",
      },
    },
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  computed: {
    question() {
      try {
        return this.item.questions[this.questionIndex];
      } catch (error) {
        return null;
      }
    },
  },
  methods: {
    cardContent: cardContent,
    // setQuestion(questionIndex) {
    //   try {
    //     this.question = this.item.questions[questionIndex];
    //   } catch (error) {
    //     this.question = null;
    //   }
    // },
    downloadPdf() {
      this.$loading(true);
      this.$http
        .get(`business/pdf/works/${this.item.id}`, { responseType: "blob" })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = this.item.title;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error)
        .finally(() => {
          this.$loading(false);
        });
    },
    setPosition(back = false) {
      if (back === true) {
        if (this.questionIndex === 0) {
          return false;
        }
        this.questionIndex--;
      } else {
        if (this.questionIndex === this.item.questions.length - 1) {
          return false;
        }
        this.questionIndex++;
      }
    },
  },
};
</script>
<style>
</style>
